import React, { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';
import yellowAlert from "src/assets/images/yellow-alert.png";
import System from 'src/helper/system';

const ExportCompliance = (props) => {
    const { SetStatus, data } = props;
    const { translation: t } = System;

    const initialState = {
        company: "",
        typeOfProduct: "",
        exportProduct: "",
        condition: ""
    };

    const [__check] = useAxiosIndicatorCheck();
    const [{ WEB_ORDER_ID, COMPLIANCE_DATA }, { get_compliance_data }, { }] = useCartStore();
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const [complianceDetail, setComplianceDetail] = useState(initialState);
    const [complianceValidation, setComplianceValidation] = useState({});

    useEffect(() => {
        async function getComplianceData() {
            await get_compliance_data({ formCode: "JEC", languageId: -10 });
        }
        getComplianceData()
    }, [])

    const onDataChange = async (field, value) => {
        await setComplianceDetail({ ...complianceDetail, [field]: value });
    };

    const handleSubmit = async (condition = '') => {
        let isValid = await onValidateData();
        if (isValid) {
            const payload = {
                "formId": COMPLIANCE_DATA.formId,
                "versionId": COMPLIANCE_DATA.version,
                "languageId": COMPLIANCE_DATA.languageId,
                "userId": "",
                "orderId": WEB_ORDER_ID.toString(),
                "answers": [
                    {
                        "questionId": 134,
                        "answerTx": complianceDetail.company,
                        "questionType": "DD",
                        "isDependant": false,
                        "subQuestion": {}
                    },
                    {
                        "questionId": 136,
                        "answerTx": complianceDetail.typeOfProduct,
                        "questionType": "DD",
                        "isDependant": false,
                        "subQuestion": {}
                    },
                    {
                        "questionId": 138,
                        "answerTx": complianceDetail.exportProduct,
                        "questionType": "DD",
                        "isDependant": false,
                        "subQuestion": {}
                    },
                    {
                        "questionId": 170,
                        "answerTx": condition,
                        "questionType": "DD",
                        "isDependant": false,
                        "subQuestion": {}
                    }
                ]
            }
            await data?.ExportComplienceCallBack(payload);
            SetStatus(false)
        } else {
            system_alert_indicator({
                name: 'ExportCompliance',
                message: t('exportCompliaceErrorMessage'),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        }
    }

    const onValidateData = () => {
        let validationModal = {};

        if (!Helper.valueIsNotNull(complianceDetail.company)) {
            validationModal.company = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.typeOfProduct)) {
            validationModal.typeOfProduct = true;
        }
        if (!Helper.valueIsNotNull(complianceDetail.exportProduct)) {
            validationModal.exportProduct = true;
        }

        setComplianceValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    }

    const closePopup = () => {
        SetStatus(false)
        remove_system_alert_indicator('ExportCompliance')
    }

    return (
        <>
            <div className="avnet-modal modal-700" id='expcompliancemodal'>
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={closePopup}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h1 className="pcn-modal-heading ps-4 pe-4 font-24"> {t('requestConfirmationOfExportControl')} <br /><span className="text-lowercase">{t('information')}</span></h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body mb-3">
                        {__check('GET_COMPLIANCE_DATA').status ? __check('GET_COMPLIANCE_DATA').render :
                            COMPLIANCE_DATA && COMPLIANCE_DATA?.questions?.map((val, i) => {
                                return (
                                    <div key={i}>
                                        {val.isDependent === false && <p><strong>{val.questionText}*</strong></p>}

                                        <ul className="mx-0 px-0">
                                            <li key={i}>
                                                <div className="mb-3">
                                                    <div class="selectbox">
                                                        <select id="" class="form-control form-control-sm"
                                                            placeholder={`- ${t('pleaseSelect')} -`}
                                                            value={complianceDetail[val.fieldName] || ""}
                                                            onChange={async ({ target: { value } }) => {
                                                                if (val.questionId === 170 && val.options.some(val => val.optionOrder === 1 && val.optionText === value)) {
                                                                    await onDataChange(val?.fieldName, value);
                                                                    await handleSubmit(value)
                                                                    await setComplianceDetail({ ...complianceDetail, [val.fieldName]: "" });
                                                                } else if (val.questionId === 170) {
                                                                    closePopup()
                                                                } else {
                                                                    await onDataChange(val?.fieldName, value);
                                                                }
                                                            }}
                                                        >
                                                            <option value="" style={{ display: 'none' }}>- {t('pleaseSelect')} -</option>
                                                            {val.options.map((options, i) => {
                                                                if (options.optionText) {
                                                                    return (
                                                                        <option value={options.optionText}>{options.optionText}</option>
                                                                    )
                                                                }
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            })
                        }
                        {Object.keys(complianceValidation).length > 0 && <p className='text-red'>{t('exportComplianceValidation')}</p>}

                        <a href={void 0} className="accordion-button px-3"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseExpinfo"
                            aria-expanded="true"
                            aria-controls="collapseOne" >{t('exportControlInformation')}</a>

                        <div className="accordion-collapse collapse" id="collapseExpinfo"
                            aria-labelledby="searchInput"
                            data-parent="#accordionExample">
                            <div className='mt-1'>
                                <img className="ms-auto me-1" src={yellowAlert} /><span>{t('exportComplianceParagraph1')}</span>
                                <p className='mb-3 mt-3'>{t('exportComplianceParagraph2')}</p>
                                <a className='text-ports' href='http://www.meti.go.jp/policy/anpo/index.html' target='_blank'>http://www.meti.go.jp/policy/anpo/index.html</a><br />
                                <p className='mb-0'><a className='text-ports' href='http://www.bis.doc.gov' target='_blank'>http://www.bis.doc.gov</a></p>
                                <p className='mb-0 mt-0'><a className='text-ports' href='http://www.bafa.de' target='_blank'>http://www.bafa.de</a></p>
                                <p className='mb-3 mt-3'>{t('exportControlInformationVerification')}</p>
                                <p className='mb-3 mt-3'>{t('exportComplianceParagraph3')}</p>
                                <p className='mb-3 mt-3'>{t('exportComplianceParagraph4')}</p>
                                <p className='mb-3 mt-3'>{t('exportComplianceParagraph5')}</p>
                                <p className='mb-3 mt-3'>{t('exportComplianceParagraph6')}</p>
                                <p className='mb-3 mt-3'>{t('exportComplianceParagraph7')}</p>
                                <p className='mb-3 mt-3'>{t('thankYouForFillingForm')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default ExportCompliance;